// Debug configuration
export const DEBUG_CONFIG = {
  // Enable debug mode from URL parameter or environment
  enabled: new URLSearchParams(window.location.search).has('debug') || 
           (import.meta as any).env?.VITE_DEBUG_MODE === 'true',
  
  // Debug mode settings
  singlePlayerMode: true,
  skipLobby: true,
  showDebugInfo: true,
  aiOpponents: 3, // Number of AI opponents in single player
  
  // Quick access via keyboard shortcut (Ctrl+Shift+D)
  enableDebugShortcut: true
}

export function isDebugMode(): boolean {
  return DEBUG_CONFIG.enabled
}